module.exports = __webpack_public_path__ + "img/dver_iz_mdf.6ae55601.svg";